/** Pure helpers of IT Admin → Email intake (testable without the API client). */

/** "INC 1234" / "SR 10531" / "#812" / "1234" → the ticket number for `/t/:number`, or null. */
export function ticketNumberOf(label: string): string | null {
  const match = /(\d{1,12})\s*$/.exec(label.trim());
  return match?.[1] ?? null;
}
